import { createSelector } from '@opengov/compose-app/reselect';

import { modalSelector } from './modalState';

export const selectModalComponentType = createSelector(
  modalSelector,
  state => state.componentType
);
